/*****************************************************************************
 * Open MCT, Copyright (c) 2014-2018, United States Government
 * as represented by the Administrator of the National Aeronautics and Space
 * Administration. All rights reserved.
 *
 * Open MCT is licensed under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * Open MCT includes source code licensed under additional open source
 * licenses. See the Open Source Licenses file (LICENSES.md) included with
 * this source code distribution or the Licensing information page available
 * at runtime from the About dialog for additional information.
 *****************************************************************************/

/**
 * Constants used by the framework layer.
 */
define('platform/framework/src/Constants',{
    MODULE_NAME: "OpenMCTWeb",
    BUNDLE_FILE: "bundle.json",
    SEPARATOR: "/",
    EXTENSION_SUFFIX: "[]",
    DEFAULT_BUNDLE: {
        "sources": "src",
        "resources": "res",
        "libraries": "lib",
        "tests": "test",
        "configuration": {},
        "extensions": {}
    },
    PRIORITY_LEVELS: {
        "fallback": Number.NEGATIVE_INFINITY,
        "default": -100,
        "none": 0,
        "optional": 100,
        "preferred": 1000,
        "mandatory": Number.POSITIVE_INFINITY
    },
    DEFAULT_PRIORITY: 0
});

